export type CraftType =
  | 'woodworking'
  | 'smithing'
  | 'goldsmithing'
  | 'clothcraft'
  | 'leathercraft'
  | 'bonecraft'
  | 'alchemy'
  | 'cooking'

export type GatheringType =
  | 'mining'
  | 'excavation'
  | 'logging'
  | 'harvesting'
  | 'chocoboDigging'
  | 'fishing'

export type MainTabType = 'crafting' | 'gathering'

export type CraftingInnerTabType = 'synthesis' | 'desynthesis'

export enum CrystalElement {
  Fire = '炎',
  Ice = '氷',
  Wind = '風',
  Earth = '土',
  Thunder = '雷',
  Water = '水',
  Light = '光',
  Dark = '闇',
}

export type Crystal = CrystalElement | string

export type SkillTierIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export interface SkillTier {
  index: SkillTierIndex
  label: string
  range: string
  min: number
  max: number
}

export interface Ingredient {
  name: string
  quantity: number
}

export interface SkillRequirement {
  craft: CraftType
  level: number
}

export interface Recipe {
  id: string
  craftType: CraftType
  tierIndex: SkillTierIndex
  result: Ingredient
  hqResults: Ingredient[]
  crystal: Crystal
  ingredients: Ingredient[]
  skills: SkillRequirement[]
}

export interface RecipesData {
  version: string
  recipes: Recipe[]
}

export type GatherProbability = 'A' | 'B' | 'C' | 'D' | 'E'

export interface GatherRecord {
  id: string
  gatheringType: GatheringType
  area: string
  fishingSpot?: string
  tierIndex?: SkillTierIndex
  name: string
  probability?: GatherProbability
  skillLevel?: number
  skillLabel?: string
  condition?: string
  bait?: string[]
}

export interface GatheringData {
  version: string
  records: GatherRecord[]
}

export interface ItemSearchResult {
  query: string
  canMake: Recipe[]
  usedIn: Recipe[]
  gatheredAt: GatherRecord[]
}
